<template>
  <div class="index">
    <div class="container privateDetail">
      <div class="chat-container" id="last">
        <!-- 消息区域 -->
        <div class="chatDetail" ref="indexref">
          <div
            class="history_box"
            v-for="(item, index) in infos.list"
            :key="index"
          >
            <!-- 右侧 -->
            <div class="my_right" v-if="receiverid != item.receiveuser_id">
              <!-- {{ item.receiveuser_id }}
              {{ receiverid }} -->
              <div class="chatDetail-right">
                <div class="chatDetail-content">
                  <div class="chatDetail-name">
                    <span
                      class="chatDetail-name-text2"
                      style="margin-right: 10px"
                      >{{ item.add_time | FormatDateTime }}</span
                    >
                    <span class="chatDetail-name-text1">我</span>
                  </div>
                  <span class="chatDetail-text">{{ item.message }}</span>
                </div>
                <div class="chatDetail-avater">
                  <img :src="infos.me.avatar" />
                </div>
              </div>
            </div>
            <!-- 左侧 -->
            <div class="my_left" v-if="receiverid == item.receiveuser_id">
              <div class="chatDetail-left">
                <!-- 接收的内容为 文本 -->
                <div class="chatDetail-avater">
                  <img :src="infos.to.avatar" />
                </div>
                <div class="chatDetail-content">
                  <div class="chatDetail-name">
                    <span>我是{{ infos.to.nick }}</span>
                    <span
                      class="chatDetail-name-text2"
                      style="margin-left: 10px"
                      >{{ item.add_time }}</span
                    >
                  </div>
                  <span class="chatDetail-text">{{ item.message }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="blankDetail"></div>
        <!-- 输入区域 -->
        <div class="chat-footer">
          <div class="textarea_section">
            <van-field
              left-icon="http://img.wish.hebyun.com.cn/images/icon_bi.png"
              v-model="content"
              type="textarea"
              placeholder="填写您想说的内容..."
              autosize
              :border="false"
              show-word-limit
              maxlength="200"
            />
          </div>
          <div class="input_submit">
            <span>*请注意安全与隐私保护</span>
            <div class="submit_btn" @click="sendMsg">发送</div>
          </div>
        </div>
      </div>
    </div>
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "privateDetail",
  components: {},
  data() {
    return {
      receiverid: "",
      content: "",
      add_time: "",
      infos: {},
      list: [],
    };
  },
  created() {
    this.senduser_id = this.$route.query.id;
    this.receiverid = localStorage.getItem("userId");
    this.queryPrivates(this.senduser_id);
    this.readMsg(this.senduser_id);
  },

  methods: {
    goback() {
      this.$router.go(-1);
    },

    // 查询聊天记录
    async queryPrivates(id) {
      let { data } = await this.$api.queryMsgList(id);
      this.infos = data;
      this.list = this.infos.list;
    },
    // 阅读消息
    readMsg(id) {
      console.log(id);
      let data = {
        receiverid: id,
      };
      this.$api.readMsg(data);
    },

    // 发送消息
    async sendMsg() {
      var aData = new Date();
      if (this.content.trim().length === 0) {
        this.$api.error("请输入内容");
        return;
      }
      let data = {
        receiverid: this.senduser_id,
        content: this.content,
      };
      console.log(data);
      await this.$api.sendMyPrivateMsg(data);
      this.$toast("发送成功");

      this.infos.list.push({
        message: this.content,
        receiverid: this.receiverid,
        add_time: aData,
      });
      this.content = "";

      var heightCss = window.getComputedStyle(this.$refs.indexref).height;
      var heightCss1 = parseInt(heightCss) + 84;
      console.log(heightCss1);
      window.scrollTo(0, heightCss1);

      // this.add_time = "";
    },
  },
  filters: {
    FormatDateTime: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>
<style scoped lang="scss">
.index {
  width: 100%;
  .container {
    margin: 0;
    padding: 0;
    width: 100%;
    height: auto;
    min-height: 100vh;
    background-color: #f9f1c6;
    padding-bottom: 25px;
    .chat-container {
      min-height: calc(100vh - 33px);
      height: auto;
      bottom: 0;
      z-index: 222;
      margin-bottom: 70px;
      .chatDetail {
        height: auto;
        background-color: #f9f1c6;
        .history_box {
          width: 375px;
          font-size: 7px;
          line-height: 25px;
          box-sizing: border-box;
          .my_left {
            padding-left: 12.5px;
            padding-right: 12.5px;
            padding-top: 5px;
            .chatDetail-left {
              display: flex;
              width: 297px;
              margin-bottom: 20px;
              .chatDetail-text::before {
                content: "";
                position: absolute;
                left: -6px;
                top: 11px;
                width: 0;
                height: 0;
                border-right: 12px solid #ffffff;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
              }
            }
          }
          .my_right {
            padding-left: 12.5px;
            padding-right: 12.5px;
            padding-top: 5px;
            .chatDetail-right {
              display: flex;
              justify-content: flex-end;
              margin-left: 51.5px;
              margin-bottom: 20px;
              .chatDetail-content {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                margin-right: 9px;
              }
              .chatDetail-avater {
                margin-right: 0;
              }
              .chatDetail-text {
                position: relative;
                background-color: #e60012;
                color: #ffffff;
                white-space: pre-wrap;
                text-align: left;
              }
              .chatDetail-text::after {
                content: "";
                position: absolute;
                top: 11px;
                right: -6px;
                width: 0;
                height: 0;
                border-left: 12px solid #e60012;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
              }
            }
          }
          .chatDetail-avater {
            width: 48px;
            height: 48px;
            overflow: hidden;
            margin-right: 12px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 48px;
              height: 48px;
              object-fit: cover;
            }
          }
          .chatDetail-content {
            display: flex;
            flex-direction: column;
            .chatDetail-name {
              font-size: 11px;
              line-height: 19px;
              color: #666666;
              text-align: left;
              .chatDetail-name-text2 {
                font-size: 10px;
                color: #999999;
              }
            }
            .chatDetail-text {
              display: block;
              position: relative;
              max-width: 260px;
              width: fit-content;
              height: auto;
              background-color: #ffffff;
              border-radius: 10px;
              box-sizing: border-box;
              margin-top: 2px;
              font-size: 14px;
              line-height: 23px;
              color: #333333;
              padding: 7px 7.5px 9px 8.5px;
              white-space: pre-wrap;
              text-align: left;
            }
          }
        }
      }
      .blankDetail {
        height: 80px;
      }
    }
    /deep/.van-icon__image {
      width: 15px;
      height: 15px;
    }
    .chat-footer {
      position: fixed;
      bottom: 0;
      width: 375px;
      background-color: #f9f1c6;
      /* 输入框 */
      .textarea_section {
        position: relative;
        font-size: 13px;
        line-height: 1;
        color: #999999;
        overflow: hidden;
        margin: 0 auto;
        width: 345px;
        height: 85.5px;
        background-color: #ffffff;
        box-shadow: 0px 1.5px 5px 0px rgba(0, 0, 0, 0.13);
        border-radius: 10px;
        border: solid 1px #e8e8e8;
        .textarea_section_nums {
          position: absolute;
          display: flex;
          right: 10px;
          bottom: 13.5px;
          span {
            font-size: 11px;
            color: #999999;
          }
        }
        /deep/.van-cell {
          background-color: transparent !important;
        }
      }

      .input_submit {
        display: flex;
        align-items: center;
        padding: 7px 15px;
        box-sizing: border-box;
        justify-content: space-between;
        span {
          font-size: 11px;
          color: #e60012;
        }
        .submit_btn {
          display: block;
          width: 100px;
          height: 31px;
          border-radius: 5px;
          background-color: #fcdfc2;
          font-size: 14px;
          line-height: 31px;
          text-align: center;
          border: solid 1px rgba(230, 0, 18, 0.22);
          color: #e60012;
        }
      }
    }
  }
}
</style>
<style lang="scss">
// 侧边功能区
.side_bars {
  position: fixed;
  right: -5px;
  bottom: 320px;
  z-index: 10000;
  img {
    display: block;
    width: 45px;
    height: 45px;
    margin-bottom: 7px;
  }
}
</style>
